import useScrollToTime from '../../hooks/useScrollToTime';
function ScrollToTime({
  scrollingElementRef,
  time,
  scrollOnViewChange
}) {
  useScrollToTime({
    scrollingElementRef,
    time,
    scrollOnViewChange
  });
  return null;
}
export default ScrollToTime;